// extracted by mini-css-extract-plugin
export default {"updateMenuInput":"updateMenu_updateMenuInput__CkY5X"};